// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1UJAy","filesListContainer":"PosDisputesFiles_filesListContainer__1-ZgB","filesButton":"PosDisputesFiles_filesButton__3vMJU"};